<template>
  <div class="hold" style="padding: 0;">
    <!-- <div class="valign-center" v-if="loading">
      <div class="spinner">
        <broken-spinner color="#554971" :thickness="2"/>
      </div>
    </div>-->
    <div class="container-fluid bg-light p-5" id="cf">
      <div>
        <h5>My Inbox</h5>
        <small class="sm-message">You have {{notifications.length}} messages and {{unreadM}} unread {{unreadM == 1 ? 'message' : 'messages'}}.</small>
      </div>
      <div class="card no-padding mt-5">
        <div class="row">
          <div class="col-sm-4 no-margin" style="border-right:2px solid #f3f6f8; padding-right:0px">
            <div class="card card-search-input">
              <div>
                <small class="pl-3 sm-message">Filter Messages</small>
                <input
                  class="form-control search-input ml-3 mr-3 mt-1 p-2 pt-3 pb-3"
                  placeholder="Enter a Search Term"
                  name
                  type="text"
                >
              </div>
            </div>

            <div class="messages">
              <div
                v-for="(notification,index) in notifications"
                :key="index"
                @click="fetch(notification.id)"
                :class="notification.read ? 'read card no-margin card-message' : 'card no-margin card-message'"
              >
                <div class="row">
                  <div class="col-sm-3">
                    <img src="@/assets/logo3.png" class="message-sender mt-4">
                  </div>

                  <div class="col-sm-9 pl-1">
                    <h5 class="text-left card-message-title">{{notification.content | truncate(40)}}</h5>
                    <small class="sm-message">{{notification.content | truncate(80)}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-8">
            <div class="message-center text-center mt-5 pt-5 mx-auto">
              <div v-if="!current_notif">
                <h5 class="text-center pt-5">Nothing to show</h5>
                <small
                  class="sm-message"
                >Click on any notification by right 👈🏻 to see full message.</small>
              </div>

              <div v-else>
                <div class="row stick-bottom">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-1 text-left">
                        <img src="@/assets/logo3.png" class="message-sender mt-5">
                      </div>

                      <div class="col-sm-6 h-100 message-convo">
                        <p>{{this.current_notif.content | replace}}</p>

                        <small
                          class="sm-message float-right"
                        >Sent : {{this.current_notif.created_at | mnt}}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.no-padding {
  padding-top: 0px;
}
.no-margin {
  margin-top: 0px;
}
.stick-bottom {
  position: absolute;
  bottom: 0;
  margin-bottom: 100px;
}
.messages {
  max-height: 550px;
  overflow-y: scroll;
}
img.message-sender {
  width: 40px;
  padding-left: 20px;
}
.message-convo {
  background: #f7f7f7;
  margin-left: 35px;
  padding-top: 40px;
  border-radius: 10px;
  padding-bottom: 40px;
  font-size: 13px;
  text-align: left;
  padding-left: 20px;
}
h5.card-message-title {
  font-size: 14px;
  font-weight: 600;
}
.card-message {
  background: #f3f6f8;
  border-bottom: 2px solid white;
  cursor: pointer;
}
.card-message:hover {
  background: #f3f6f8;
}
.read {
  background: white;
  border-bottom: 2px solid #f3f6f3;
}
.form-control {
  box-shadow: 0 1.2px 5.68px 0 rgba(0, 0, 0, 0.12);
  border: 0px;
  border-radius: 0px;
  font-size: 13px;
  color: #e4e4e4;
}
.search-input {
  width: 90%;
}
.card-search-input {
  margin-top: 0px;
  background: #f7f7f7;
  border: 0.5px solid #ffffff;
}
small.sm-message {
  opacity: 0.5;
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";

export default {
  data() {
    return {
      current_notif: ""
    };
  },
  methods: {
    fetch(id) {
      this.notifications.filter(s => {
        return s.id == id ? (s.read = true) : false;
      });
      //find and update notification from server
      this.$http
        .patch(`${BASE_API}/v1/tutor/dashboard-notifications/${id}`)
        .then(e => {
          console.log(id);
          this.current_notif = this.notifications.filter(s => {
            return s.id == id;
          })[0];
        })
        .catch(e => {
          console.log("Something went wrong");
        });
      console.log(this.current_notif);
    }
  },
  computed: {
    notifications() {
      return this.$auth.user().dashboard_notifications;
    },
    readM() {
        return this.$auth.user().dashboard_notifications.filter((s) => s.read).length;
    },
    unreadM() {
        return this.$auth.user().dashboard_notifications.filter((s) => !s.read).length;
    }
  },
  filters: {
    truncate(string, length) {
      string = string.replace(/<[^>]*>?/gm, "");
      return string.substring(0, length) + "...";
    },
    replace(string) {
      return string.replace(/<[^>]*>?/gm, "");
    },
    mnt(t) {
      return moment(t).format("Do MMM, YYYY");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Inbox/IndexTest.vue